/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddOrganizationToOrganizationGroupRequest
 */
export interface AddOrganizationToOrganizationGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationToOrganizationGroupRequest
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationToOrganizationGroupRequest
     */
    code?: string | null;
}

/**
 * Check if a given object implements the AddOrganizationToOrganizationGroupRequest interface.
 */
export function instanceOfAddOrganizationToOrganizationGroupRequest(value: object): value is AddOrganizationToOrganizationGroupRequest {
    return true;
}

export function AddOrganizationToOrganizationGroupRequestFromJSON(json: any): AddOrganizationToOrganizationGroupRequest {
    return AddOrganizationToOrganizationGroupRequestFromJSONTyped(json, false);
}

export function AddOrganizationToOrganizationGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddOrganizationToOrganizationGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'code': json['code'] === undefined ? undefined : json['code'] === null ? null : json['code'],
    };
}

export function AddOrganizationToOrganizationGroupRequestToJSON(json: any): AddOrganizationToOrganizationGroupRequest {
    return AddOrganizationToOrganizationGroupRequestToJSONTyped(json, false);
}

export function AddOrganizationToOrganizationGroupRequestToJSONTyped(value?: AddOrganizationToOrganizationGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'code': value['code'],
    };
}

